PJQ.models.companies = {};

PJQ.models.companies.UserLimits = PJQ.models.BaseModel.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'userlimits'
            }
        ]);
    }
});